/* Media page — AD / Scheduler / Tech Specialist (AJ 2026-10-14). Tabs:
 *   Website  — Home page carousel + Team photos (one shared dataset for every role)
 *   Sponsors — the Sponsors screen (cards/table, logos, terms)
 * Doc: /app/docs/MEDIA_PAGE.md */
import React, { useState } from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import HeroCarouselManager from './HeroCarouselManager';
import TeamPhotosManager from './TeamPhotosManager';
import SponsorsMediaPanel from '../SponsorsMediaPanel';

export default function MediaPage({ orgId, isDark }) {
  const [tab, setTab] = useState('website');
  if (!orgId) return null;
  const card = isDark ? 'bg-slate-800/50 border-slate-700' : 'bg-white border-slate-200';
  const h = `text-sm font-semibold ${isDark ? 'text-white' : 'text-slate-900'}`;
  return (
    <div className="space-y-4" data-testid="media-page">
      <div className="flex items-center gap-2">
        {[['website', 'Website'], ['sponsors', 'Sponsors']].map(([k, l]) => (
          <Button key={k} size="sm" variant={tab === k ? 'default' : 'outline'} onClick={() => setTab(k)}
            className={tab === k ? 'bg-amber-600 hover:bg-amber-700 text-white' : ''} data-testid={`media-tab-${k}`}>{l}</Button>
        ))}
      </div>
      {tab === 'sponsors' ? <SponsorsMediaPanel orgId={orgId} /> : (
        <>
          <Card className={card}><CardContent className="p-4 space-y-2">
            <div className={h}>Home page carousel</div>
            <HeroCarouselManager orgId={orgId} isDark={isDark} />
          </CardContent></Card>
          <Card className={card}><CardContent className="p-4 space-y-2">
            <div className={h}>Team photos</div>
            <TeamPhotosManager orgId={orgId} isDark={isDark} />
          </CardContent></Card>
        </>
      )}
    </div>
  );
}
